import {
  TableBody as MuiTableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { flexRender, Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const TableBody = <T extends object>({ table }: { table: Table<T> }) => {
  const { t } = useTranslation();

  return (
    <MuiTableBody>
      {table.getRowModel().rows.map((row) => (
        <TableRow key={row.id} hover>
          {row.getVisibleCells().map((cell) => (
            <TableCell key={cell.id}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      ))}
      {table.getRowCount() === 0 && (
        <TableRow>
          <TableCell colSpan={table._getColumnDefs().length}>
            <Typography sx={{ textAlign: "center", p: [1, 2] }}>
              {t("table.noResults")}
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </MuiTableBody>
  );
};
